import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let createRouter = new Router({
    mode: 'history',
    routes: [{
            path: '/',
            name: 'home',
            meta: {
                title: '首页'
            },
            component: () => import('./pages/Home.vue')
        },{
            path: '/productServices',
            name: 'productServices',
            meta: {
                title: '产品服务'
            },
            component: () => import('./pages/ProductServices.vue')
        },{
            path: '/aboutUs',
            name: 'aboutUs',
            meta: {
                title: '关于我们'
            },
            component: () => import('./pages/AboutUs.vue')
        },{
            path: '/join',
            name: 'join',
            meta: {
                title: '关于我们'
            },
            component: () => import('./pages/Join.vue')
        }

    ]
})

export default createRouter